import { useState, useEffect } from 'react';
import axios from 'axios';

function usePassengerInformationFormStep2(
  setStep,
  controlNumberPNR,
  setGlobalPNR,
) {
  const [codePNR, setCodePNR] = useState('');
  const [isFetching, setIsFetching] = useState(false);
  const [recoveryResponse, setRecoveryResponse] = useState(null);
  const [buttonAvailable, setButtonAvailable] = useState(false);

  function getCodePNR(event) {
    const value = event?.target?.value;
    setCodePNR(value)
  }

  async function consultReservation() {
    if (isFetching) return;
    setIsFetching(true);
    try {
      const url = 'https://travelflight.pdtcomunicaciones.com/api/retrieve';
      const result = await axios.post(url,
        {
          record: codePNR,
        }
      );
      if (result) {
        if (result.error) {
          console.log("error: ", result.error);
        }
        else {
          const data = result?.data;
          setRecoveryResponse(data);
          setGlobalPNR(data)
          setCodePNR('');
        }
      }
    } catch (error) {
      console.log("Error in consultReservation()", error)
    }
    finally {
      setIsFetching(false);
    }
  }

  function continueTo() {
    setStep(3);
  }

  useEffect(() => {
    const status = codePNR && codePNR.length > 5
    setButtonAvailable(status);
    
    if(codePNR && codePNR.length > 5 && buttonAvailable){
      consultReservation()
    }


  }, [codePNR,buttonAvailable])


  function automatization() {
    if (!codePNR) {
      setCodePNR(controlNumberPNR)
    }
  }


  useEffect(() => {
    if (controlNumberPNR) {
      automatization()
    }
  }, []);

  return {
    codePNR,
    getCodePNR,
    consultReservation,
    isFetching,
    recoveryResponse,
    buttonAvailable,
    continueTo
  }
}
export default usePassengerInformationFormStep2;
